// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__DIKRn","content":"Header_content__8xlCY","user":"Header_user__nKgZ2"};